const errorMessages: { [key: string]: string } = {
	AdfJamTurnOver: 'mfp device error status:AdfJamTurnOver',
	AdfJamFeed: 'mfp device error status:AdfJamFeed',
	AdfJamTransfer: 'mfp device error status:AdfJamTransfer',
	AdfJamMidTray: 'mfp device error status:AdfJamMidTray',
	AdfJamSingleFeed: 'mfp device error status:AdfJamSingleFeed',
	AdfJamExit: 'mfp device error status:AdfJamExit',
	AdfUnsetEject: 'mfp device error status:AdfUnsetEject',
	AdfUnsetFeed: 'mfp device error status:AdfUnsetFeed',
	AdfUnsetTransfer: 'mfp device error status:AdfUnsetTransfer',
	AdfUnsetMidTray: 'mfp device error status:AdfUnsetMidTray',
	AdfUnsetReverse: 'mfp device error status:AdfUnsetReverse',
	AdfUnsetSingleFeed: 'mfp device error status:AdfUnsetSingleFeed',
	AdfDoorCisGuide: 'mfp device error status:AdfDoorCisGuide',
	AdfDocumentTray: 'mfp device error status:AdfDocumentTray',
	ScannerLockError: 'mfp device error status:ScannerLockError',
	TrayUnsetTray1: 'mfp device error status:TrayUnsetTray1',
	TrayUnsetTray2: 'mfp device error status:TrayUnsetTray2',
	TrayUnsetTray3: 'mfp device error status:TrayUnsetTray3',
	TrayUnsetTray4: 'mfp device error status:TrayUnsetTray4',
	TrayUnsetLct: 'mfp device error status:TrayUnsetLct',
	OhpLengthFeedDisable: 'mfp device error status:OhpLengthFeedDisable',
	HddFull: 'mfp device error status:HddFull',
	BoxAccessCheckError: 'mfp device error status:BoxAccessCheckError',
	PrinterJamFeedTray1: 'mfp device error status:PrinterJamFeedTray1',
	PrinterJamFeedTray2: 'mfp device error status:PrinterJamFeedTray2',
	PrinterJamFeedTray3: 'mfp device error status:PrinterJamFeedTray3',
	PrinterJamFeedTray4: 'mfp device error status:PrinterJamFeedTray4',
	PrinterJamFeedTrayManual: 'mfp device error status:PrinterJamFeedTrayManual',
	PrinterJamFeedTrayLcc: 'mfp device error status:PrinterJamFeedTrayLcc',
	PrinterJamFeedTray5: 'mfp device error status:PrinterJamFeedTray5',
	PrinterJamFeedTrayDuplex: 'mfp device error status:PrinterJamFeedTrayDuplex',
	PrinterJamVTransfer: 'mfp device error status:PrinterJamVTransfer',
	PrinterJam2ndTransfer: 'mfp device error status:PrinterJam2ndTransfer',
	PrinterJamPaperEject: 'mfp device error status:PrinterJamPaperEject',
	PrinterJamDuplexTransfer: 'mfp device error status:PrinterJamDuplexTransfer',
	PrinterJamTransLcc: 'mfp device error status:PrinterJamTransLcc',
	PrinterJamTransTray5: 'mfp device error status:PrinterJamTransTray5',
	PrinterJamHTransTray3Tray4: 'mfp device error status:PrinterJamHTransTray3Tray4',
	PrinterJamMRollerTray3Tray4: 'mfp device error status:PrinterJamMRollerTray3Tray4',
	PrinterJamOptionTransfer: 'mfp device error status:PrinterJamOptionTransfer',
	PrinterJamOptionEject: 'mfp device error status:PrinterJamOptionEject',
	PrinterJamPaperReamEject: 'mfp device error status:PrinterJamPaperReamEject',
	PrinterJamFolder: 'mfp device error status:PrinterJamFolder',
	PrinterJamStaple: 'mfp device error status:PrinterJamStaple',
	PrinterJamFns: 'mfp device error status:PrinterJamFns',
	TonerEmptyStopYellow: 'mfp device error status:TonerEmptyStopYellow',
	TonerEmptyStopMagenta: 'mfp device error status:TonerEmptyStopMagenta',
	TonerEmptyStopCyan: 'mfp device error status:TonerEmptyStopCyan',
	TonerEmptyStopBlack: 'mfp device error status:TonerEmptyStopBlack',
	SizeChanged: 'mfp device error status:SizeChanged',
	KindChanged: 'mfp device error status:KindChanged',
	ControllerPower2: 'mfp device error status:ControllerPower2',
	PrinterUnsetTray5: 'mfp device error status:PrinterUnsetTray5',
	TrayAbnormalError: 'mfp device error status:TrayAbnormalError',
	PaperTraySetDefect2: 'mfp device error status:PaperTraySetDefect2',
	AutoDetectPaperError_Auto: 'mfp device error status:AutoDetectPaperError_Auto',
	AutoDetectPaperError_Manual: 'mfp device error status:AutoDetectPaperError_Manual',
	PrinterUnsetFront: 'mfp device error status:PrinterUnsetFront',
	PrinterUnsetTrans: 'mfp device error status:PrinterUnsetTrans',
	PrinterUnsetManual: 'mfp device error status:PrinterUnsetManual',
	PrinterUnsetLccHTrans: 'mfp device error status:PrinterUnsetLccHTrans',
	PrinterUnsetLeft: 'mfp device error status:PrinterUnsetLeft',
	PrinterUnsetFuser: 'mfp device error status:PrinterUnsetFuser',
	PrinterUnsetRight: 'mfp device error status:PrinterUnsetRight',
	PrinterUnsetDuplex: 'mfp device error status:PrinterUnsetDuplex',
	PrinterUnsetFeed: 'mfp device error status:PrinterUnsetFeed',
	PrinterUnsetLevelTransfer: 'mfp device error status:PrinterUnsetLevelTransfer',
	PrinterUnsetOptionTransfer: 'mfp device error status:PrinterUnsetOptionTransfer',
	Unset: 'mfp device error status:Unset',
	IuLifeYellow: 'mfp device error status:IuLifeYellow',
	IuLifeMagenta: 'mfp device error status:IuLifeMagenta',
	IuLifeCyan: 'mfp device error status:IuLifeCyan',
	IuLifeBlack: 'mfp device error status:IuLifeBlack',
	DcLifeYellow: 'mfp device error status:DcLifeYellow',
	DcLifeMagenta: 'mfp device error status:DcLifeMagenta',
	DcLifeCyan: 'mfp device error status:DcLifeCyan',
	DcLifeBlack: 'mfp device error status:DcLifeBlack',
	DevCLifeYellow: 'mfp device error status:DevCLifeYellow',
	DevCLifeMagenta: 'mfp device error status:DevCLifeMagenta',
	DevCLifeCyan: 'mfp device error status:DevCLifeCyan',
	DevCLifeBlack: 'mfp device error status:DevCLifeBlack',
	DeveloperLifeBlack: 'mfp device error status:DeveloperLifeBlack',
	TransCleanerUnitLife: 'mfp device error status:TransCleanerUnitLife',
	FuserUnitLife: 'mfp device error status:FuserUnitLife',
	TonerBottoleUnsetYellow: 'mfp device error status:TonerBottoleUnsetYellow',
	TonerBottoleUnsetMagenta: 'mfp device error status:TonerBottoleUnsetMagenta',
	TonerBottoleUnsetCyan: 'mfp device error status:TonerBottoleUnsetCyan',
	TonerBottoleUnsetBlack: 'mfp device error status:TonerBottoleUnsetBlack',
	TonerCartridgeUnsetYellow: 'mfp device error status:TonerCartridgeUnsetYellow',
	TonerCartridgeUnsetMagenta: 'mfp device error status:TonerCartridgeUnsetMagenta',
	TonerCartridgeUnsetCyan: 'mfp device error status:TonerCartridgeUnsetCyan',
	TonerCartridgeUnsetBlack: 'mfp device error status:TonerCartridgeUnsetBlack',
	IuUnsetYellow: 'mfp device error status:IuUnsetYellow',
	IuUnsetMagenta: 'mfp device error status:IuUnsetMagenta',
	IuUnsetCyan: 'mfp device error status:IuUnsetCyan',
	IuUnsetBlack: 'mfp device error status:IuUnsetBlack',
	DcUnsetYellow: 'mfp device error status:DcUnsetYellow',
	DcUnsetMagenta: 'mfp device error status:DcUnsetMagenta',
	DcUnsetCyan: 'mfp device error status:DcUnsetCyan',
	DcUnsetBlack: 'mfp device error status:DcUnsetBlack',
	DevCUnsetYellow: 'mfp device error status:DevCUnsetYellow',
	DevCUnsetMagenta: 'mfp device error status:DevCUnsetMagenta',
	DevCUnsetCyan: 'mfp device error status:DevCUnsetCyan',
	DevCUnsetBlack: 'mfp device error status:DevCUnsetBlack',
	IuMissetYellow: 'mfp device error status:IuMissetYellow',
	IuMissetMagenta: 'mfp device error status:IuMissetMagenta',
	IuMissetCyan: 'mfp device error status:IuMissetCyan',
	IuMissetBlack: 'mfp device error status:IuMissetBlack',
	DcMissetYellow: 'mfp device error status:DcMissetYellow',
	DcMissetMagenta: 'mfp device error status:DcMissetMagenta',
	DcMissetCyan: 'mfp device error status:DcMissetCyan',
	DcMissetBlack: 'mfp device error status:DcMissetBlack',
	DevCMissetYellow: 'mfp device error status:DevCMissetYellow',
	DevCMissetMagenta: 'mfp device error status:DevCMissetMagenta',
	DevCMissetCyan: 'mfp device error status:DevCMissetCyan',
	DevCMissetBlack: 'mfp device error status:DevCMissetBlack',
	TonerCartridgeMissetYellow: 'mfp device error status:TonerCartridgeMissetYellow',
	TonerCartridgeMissetMagenta: 'mfp device error status:TonerCartridgeMissetMagenta',
	TonerCartridgeMissetCyan: 'mfp device error status:TonerCartridgeMissetCyan',
	TonerCartridgeMissetBlack: 'mfp device error status:TonerCartridgeMissetBlack',
	TonerCartridgeResetErrorYellow: 'mfp device error status:TonerCartridgeResetErrorYellow',
	TonerCartridgeResetErrorMagenta: 'mfp device error status:TonerCartridgeResetErrorMagenta',
	TonerCartridgeResetErrorCyan: 'mfp device error status:TonerCartridgeResetErrorCyan',
	TonerCartridgeResetErrorBlack: 'mfp device error status:TonerCartridgeResetErrorBlack',
	TonerCartridgeNonGenuineErrorBlack: 'mfp device error status:TonerCartridgeNonGenuineErrorBlack',
	IUResetErrorYellow: 'mfp device error status:IUResetErrorYellow',
	IUResetErrorMagenta: 'mfp device error status:IUResetErrorMagenta',
	IUResetErrorCyan: 'mfp device error status:IUResetErrorCyan',
	IUResetErrorBlack: 'mfp device error status:IUResetErrorBlack',
	IUNonGenuineErrorBlack: 'mfp device error status:IUNonGenuineErrorBlack',
	TransBeltUnitUnset: 'mfp device error status:TransBeltUnitUnset',
	FuserUnitUnset: 'mfp device error status:FuserUnitUnset',
	UsedTonerBottleFull: 'mfp device error status:UsedTonerBottleFull',
	RemovePaperOnFinisherTray: 'mfp device error status:RemovePaperOnFinisherTray',
	PulloutPaperlOnManualTray: 'mfp device error status:PulloutPaperlOnManualTray',
	TransRollerUnitLifeService: 'mfp device error status:TransRollerUnitLifeService',
	OzonFilterLifeService: 'mfp device error status:OzonFilterLifeService',
	DustPaperCleanerService: 'mfp device error status:DustPaperCleanerService',
	TransBeltUnitLife: 'mfp device error status:TransBeltUnitLife',
	MaintenanceKitLife: 'mfp device error status:MaintenanceKitLife',
	PmCounterOver_E: 'mfp device error status:PmCounterOver_E',
	FuserPlugComesOff: 'mfp device error status:FuserPlugComesOff',
	SmokeFilterUnitLife: 'mfp device error status:SmokeFilterUnitLife',
	PrinterFatal: 'mfp device error status:PrinterFatal',
	ScannerFatal: 'mfp device error status:ScannerFatal',
	PrinterComm: 'mfp device error status:PrinterComm',
	ScannerComm: 'mfp device error status:ScannerComm',
};

export default errorMessages;
